import React, { useEffect, useState,useRef,useContext } from "react";
import {
  // Button,
  Input,
  FormControl,
  FormLabel,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerCloseButton,
  DrawerBody,
  DrawerFooter,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Grid,
  Image,
  Select,
  Textarea,
  Spinner,
} from "@chakra-ui/react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Card,
  CardHeader,
  CardBody,
  Heading,
  Stack,
  Box,
  StackDivider,

  useToast,
  Button,
} from "@chakra-ui/react";

import { Flex, IconButton, Modal, ModalCloseButton, ModalContent, ModalOverlay, Text, Tooltip } from "@chakra-ui/react";
import { BsFileEarmarkText } from "react-icons/bs";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { MyContext } from "../../MyProvider";
import AdminLogin from "../AdminNav/Login";
import { Cell, FilterTabs, Ledger, LedgerRow, LoadingState, Panel, RowActions, SectionTitle, StatusMark } from "../../components/ui";
import { API_URL } from "../../Apis/config";
import LetterheadSheet from "../../components/LetterheadSheet";
const rupees = (amount) => `\u20B9${Number(amount || 0).toLocaleString("en-IN")}`;

const initials = (client) =>
  [client.fname, client.lname]
    .filter(Boolean)
    .map((part) => part.trim()[0])
    .join("")
    .toUpperCase();

// One figure on the account line. The closing figure sits over a double rule, the bookkeeper's mark for a final total.
function Figure({ label, value, note, owed, closing }) {
  return (
    <Box>
      <Text fontSize="sm" fontWeight={600} color="stone.700">
        {label}
      </Text>
      <Text
        as="span"
        display="inline-block"
        fontSize={{ base: "xl", md: "2xl" }}
        fontWeight={600}
        lineHeight="1.3"
        px={owed ? 2 : 0}
        mx={owed ? -2 : 0}
        borderRadius="sm"
        bg={owed ? "turmeric.500" : "transparent"}
        borderBottom={closing ? "4px double" : "none"}
        borderColor="ink"
      >
        {rupees(value)}
      </Text>
      {note && (
        <Text fontSize="sm" color={owed ? "ink" : "tulsi.700"} fontWeight={600}>
          {note}
        </Text>
      )}
    </Box>
  );
}

function Fact({ label, children, wide }) {
  return (
    <Box gridColumn={wide ? { base: "1 / -1", xl: "span 2" } : undefined} minW={0}>
      <Text fontSize="sm" fontWeight={600} color="stone.700">
        {label}
      </Text>
      {children ? (
        <Text overflowWrap="anywhere">{children}</Text>
      ) : (
        <Text color="stone.500">Not recorded</Text>
      )}
    </Box>
  );
}

export default function UserDetailsCard() {

  const {appointData,userData,eventData,horoData,userApi,eventApi,appointApi,horoApi}=useContext(MyContext);
  const navigate=useNavigate();
  const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);
  const [isDeleteUserOpen, setIsDeleteUserOpen] = useState(false);
  const {
    isOpen: isOpenModal1,
    onOpen: onOpenModal1,
    onClose: onCloseModal1,
  } = useDisclosure();
  const toast = useToast();
  const {
    isOpen: isOpenModal2,
    onOpen: onOpenModal2,
    onClose: onCloseModal2,
  } = useDisclosure();

  const {
    isOpen: isOpenModalHoro,
    onOpen: onOpenModalHoro,
    onClose: onCloseModalHoro,
  } = useDisclosure();
  const {
    isOpen: isOpenEditApoi1,
    onOpen: onOpenEditApoi1,
    onClose: onCloseEditApoi1,
  } = useDisclosure();
  const {
    isOpen: isOpenEditEvent1,
    onOpen: onOpenEditEvent1,
    onClose: onCloseEditEvent1,
  } = useDisclosure();

  const {
    isOpen: isOpenEditHoro,
    onOpen: onOpenEditHoro,
    onClose: onCloseEditHoro,
  } = useDisclosure();
  const {
    isOpen: isOpenUser,
    onOpen: onOpenUser,
    onClose: onCloseUser,
  } = useDisclosure();

  const [scrollBehavior, setScrollBehavior] = useState("inside");
  const initialRef = useRef(null);
  const finalRef = useRef(null);
  const { id } = useParams();
  


  const [appointments, setAppointments] = useState([]);
  const [eventD, setEventD] = useState([]);
  const [userD, setUserD] = useState("");
  const [horoD, setHoroD] = useState([]);

  

  const [selectedEvent, setSelectedEvent] = useState(null);
  const [formData, setFormData] = useState({});
  // const [update, setUpdate] = useState(false);
  
  const [isDeleteAlertOpenEvent, setIsDeleteAlertOpenEvent] = useState(false);
  const [isDeleteAlertOpenHoro, setIsDeleteAlertOpenHoro] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [bookingTab, setBookingTab] = useState(null);
  const [letterheadEvent, setLetterheadEvent] = useState(null);
  const [photoOpen, setPhotoOpen] = useState(false);

  useEffect(() => {
   setAppointments(appointData.filter((ele)=>ele.userId==id));
   setEventD(eventData.filter((ele)=>ele.userId==id));
   setHoroD(horoData.filter((ele)=>ele.userId==id));
   setUserD(userData.filter((ele)=>ele._id==id))

  }, [id,appointData,eventData,horoData,userData]);

  const updateHoro=async()=>{

    await horoApi();
    await userApi();
  };

  const updateEvent=async()=>{
    await eventApi();
    await userApi();
  };

  const updateAppoint=async()=>{
    await appointApi();
    // await userApi();
  };

  const updateUser=async()=>{
    await userApi();
  };

  const deleteUser=async()=>{
    await userApi();
    await eventApi();
    await horoApi();
    await appointApi();
    
    
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "image") {
      let imageD = e.target.files[0];
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: imageD,
      }));
    } else if (name == "DOB") {
      const [year, month, day] = value.split("-");
      const formattedDate = `${day}/${month}/${year}`;
      // console.log("value")
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: formattedDate,
      }));
    } else if (name == "eventDate") {
      const [year, month, day] = value.split("-");
      const formattedDate = `${day}/${month}/${year}`;
      // console.log(value)
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: formattedDate,
      }));
    } else if (name == "appointmentDate") {
      const [year, month, day] = value.split("-");
      const formattedDate = `${day}/${month}/${year}`;
      //   console.log(value)
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: formattedDate,
      }));
    } else if (name.startsWith("gautarm")) {
      const [x, index1, gkey] = name.split("-");

      setFormData((prevFormData) => ({
        ...prevFormData,
        [`gautarm.${index1}.${gkey}`]: value,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };
  const handleSubmit = () => {
    // console.log(formData);
    // Here, you can use the formData object as the payload
    // to send it to your backend or perform any necessary actions
    axios
      .patch(
        `${API_URL}/appointment/${selectedEvent._id}`,
        formData
      )
      .then((res) => {
        updateAppoint();
        toast({
          title: "Appointment updated",
          description: "Appointment has been updated successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        onCloseEditApoi1();
        setFormData({});
      })
      .catch((err) => {
        toast({
          title: "Error",
          description:"Error occured while updating appointment",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };

  const hendelUserD = async () => {
    if (formData.image) {
      let imageUrl = "";
      try {
        const imageData = new FormData();
        imageData.append("file", formData.image);
        imageData.append("upload_preset", "tekxwxfz"); // Replace with your Cloudinary unsigned upload preset

        const response = await axios.post(
          `https://api.cloudinary.com/v1_1/dzidj8k7j/auto/upload`,
          imageData
        );
        imageUrl = response.data.secure_url;
        axios
          .patch(
            `${API_URL}/users/${selectedEvent._id}`,
            { ...formData, image: imageUrl }
          )
          .then((res) => {
            updateUser();
            toast({
              title: "User updated",
              description: "User has been updated successfully.",
              status: "success",
              duration: 5000,
              isClosable: true,
            });
            onCloseUser();
            setFormData({});
          })
          .catch((err) => {
            toast({
              title: "Error",
              description:
                "Error occurred while updating user",
              status: "error",
              duration: 5000,
              isClosable: true,
            });
          });

        setFormData({});
        onCloseEditEvent1();
      } catch (error) {
        console.error(error);
        return;
      }
    } else {
      axios
        .patch(
          `${API_URL}/users/${selectedEvent._id}`,
          formData
        )
        .then((res) => {
          updateUser();
          toast({
            title: "User updated",
            description: "User has been updated successfully.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          onCloseUser();
          setFormData({});
        })
        .catch((err) => {
          toast({
            title: "Error",
            description:"Error occured while updating user",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        });
    }
  };
  const handleSubmitEvent = async () => {
    if (formData.image) {
      let imageUrl = "";
      try {
        const imageData = new FormData();
        imageData.append("file", formData.image);
        imageData.append("upload_preset", "tekxwxfz"); // Replace with your Cloudinary unsigned upload preset

        const response = await axios.post(
          `https://api.cloudinary.com/v1_1/dzidj8k7j/auto/upload`,
          imageData
        );
        imageUrl = response.data.secure_url;
        axios
          .patch(
            `${API_URL}/event/${selectedEvent._id}`,
            { ...formData, image: imageUrl }
          )
          .then((res) => {
            updateEvent()
            toast({
              title: "Event updated",
              description: "Event has been updated successfully.",
              status: "success",
              duration: 5000,
              isClosable: true,
            });
            onCloseEditEvent1();
            setFormData({});
          })
          .catch((err) => {
            toast({
              title: "Error",
              description:
                "Error occured while updating event",
              status: "error",
              duration: 5000,
              isClosable: true,
            });
          });
      } catch (error) {
        console.error(error);
        return;
      }
    } else {
      axios
        .patch(
          `${API_URL}/event/${selectedEvent._id}`,
          formData
        )
        .then((res) => {
          updateEvent();
          toast({
            title: "Event updated",
            description: "Event has been updated successfully.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          onCloseEditEvent1();
          setFormData({});
        })
        .catch((err) => {
          toast({
            title: "Error",
            description:"Error occured while updating event",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        });
    }
  };

  const handleSubmitHoro = async () => {
    if (formData.image) {
      let imageUrl = "";
      try {
        const imageData = new FormData();
        imageData.append("file", formData.image);
        imageData.append("upload_preset", "tekxwxfz"); // Replace with your Cloudinary unsigned upload preset

        const response = await axios.post(
          `https://api.cloudinary.com/v1_1/dzidj8k7j/auto/upload`,
          imageData
        );
        imageUrl = response.data.secure_url;
        axios
          .patch(
            `${API_URL}/horo/${selectedEvent._id}`,
            { ...formData, image: imageUrl }
          )
          .then((res) => {
            updateHoro();
            toast({
              title: "Astro updated",
              description: "Astro has been updated successfully.",
              status: "success",
              duration: 5000,
              isClosable: true,
            });
            onCloseEditHoro();
            setFormData({});
          })
          .catch((err) => {
            toast({
              title: "Error",
              description:"Error occured while updating astro",
              status: "error",
              duration: 5000,
              isClosable: true,
            });
          });
      } catch (error) {
        console.error(error);
        return;
      }
    } else {
      axios
        .patch(
          `${API_URL}/horo/${selectedEvent._id}`,
          formData
        )
        .then((res) => {
          updateHoro();
          toast({
            title: "Astro updated",
            description: "Astro has been updated successfully.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          onCloseEditHoro();
          setFormData({});
        })
        .catch((err) => {
          toast({
            title: "Error",
            description:
              "Error occured while upating astro",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        });
    }
  };
  
  
  const onDeleteConfirm = () => {
    setIsDeleteAlertOpen(false);
    // Perform delete logic here
    axios
      .delete(
        `${API_URL}/appointment/${selectedEvent._id}`
      )
      .then((res) => {
        updateAppoint();
        toast({
          title: "Appointment Deleted",
          description: "Appointment has been deleted successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        
        // Perform any necessary actions after successful deletion
      })
      .catch((err) => {
        toast({
          title: "Error",
          description:
            "Error occured while deleting appointment",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };
  const onDeleteConfirmEvent = () => {
    setIsDeleteAlertOpenEvent(false);
    // Perform any necessary actions after successful deletion

    axios
      .delete(
        `${API_URL}/event/${selectedEvent._id}`
      )
      .then((res) => {
        updateEvent();
        toast({
          title: "Event Deleted",
          description: "Event has been deleted successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        
        
        
      })
      .catch((err) => {
        toast({
          title: "Error",
          description:
            "Error occured while deleting event",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };

  const onDeleteConfirmHoro = () => {
    setIsDeleteAlertOpenHoro(false);
    axios
      .delete(
        `${API_URL}/horo/${selectedEvent._id}`
      )
      .then((res) => {
        updateHoro();
        toast({
          title: "Astro Deleted",
          description: "Astro has been deleted successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        
        
      })
      .catch((err) => {
        toast({
          title: "Error",
          description:
            "Error occured while deleting astro",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };
  const onDeleteConfirmUser = () => {
    setIsDeleteUserOpen(false);
    axios
      .delete(
        `${API_URL}/users/${userD[0]._id}`
      )
      .then((res) => {
        deleteUser();
        toast({
          title: "User Deleted",
          description: "User has been deleted successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        
        
        navigate("/admin/welcome");
        // Perform any necessary actions after successful deletion
      })
      .catch((err) => {
        toast({
          title: "Error",
          description:
            "Error occured while deleting astro",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };

  const openEventModal = (event, model) => {
    setSelectedEvent(event);
    onOpenModal2();
  };

  const openHoroModal = (event) => {
    setSelectedEvent(event);
    onOpenModalHoro();
  };
  const openUser = () => {
    setSelectedEvent(userD[0]);
    onOpenUser();
  };
  const onOpenEditAppointment = (event) => {
    setSelectedEvent(event);
    onOpenEditApoi1();
  };
  const openEditEvent = (event) => {
    setSelectedEvent(event);
    onOpenEditEvent1();
  };

  const openEditHoro = (event) => {
    setSelectedEvent(event);
    onOpenEditHoro();
  };
  const openAppointmentModal = (event) => {
    setSelectedEvent(event);
    onOpenModal1();
  };

  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }
  if (!userD || userD.length === 0) {
    return <LoadingState>Loading client details</LoadingState>;
  }

  const client = userD[0];
  const family = client.family || [];
  const total = client.remainAmmount + client.paidAmmount;
  const openFirst = (status) => (a, b) => (a[status] === "Pending" ? 0 : 1) - (b[status] === "Pending" ? 0 : 1);
  const bookings = {
    appointments: [...appointments].sort(openFirst("appointmentStatus")),
    events: [...eventD].sort(openFirst("eventStatus")),
    astro: [...horoD].sort(openFirst("horoStatus")),
  };
  const statusKey = { appointments: "appointmentStatus", events: "eventStatus", astro: "horoStatus" };
  // Open the first tab that has something pending, else the first with any bookings.
  const defaultTab =
    Object.keys(bookings).find((key) => bookings[key].some((el) => el[statusKey[key]] === "Pending")) ||
    Object.keys(bookings).find((key) => bookings[key].length > 0) ||
    "appointments";
  const activeTab = bookingTab || defaultTab;

  return (
    <>
      <Flex justify="space-between" align={{ base: "flex-start", md: "center" }} gap={4} wrap="wrap" mb={5}>
        <Flex align="center" gap={4} minW={0}>
          {client.image ? (
            <Box
              as="button"
              type="button"
              onClick={() => setPhotoOpen(true)}
              aria-label={`Enlarge photo of ${client.fname}`}
              title="Enlarge photo"
              flexShrink={0}
              borderRadius="lg"
              cursor="zoom-in"
              _hover={{ boxShadow: "0 0 0 3px #F1CFD4" }}
            >
              <Image src={client.image} alt="" border="1px solid" borderColor="stone.200" bg="white" boxSize={{ base: "96px", md: "144px" }} objectFit="cover" borderRadius="lg" />
            </Box>
          ) : (
            <Flex
              boxSize={{ base: "96px", md: "144px" }}
              flexShrink={0}
              align="center"
              justify="center"
              borderRadius="lg"
              bg="kumkum.50"
              color="kumkum.500"
              fontFamily="heading"
              fontSize={{ base: "4xl", md: "6xl" }}
              aria-hidden="true"
            >
              {initials(client)}
            </Flex>
          )}
          <Box minW={0}>
            <Heading as="h1" fontSize={{ base: "3xl", md: "4xl" }} lineHeight="1.15">
              {client.fname} {client.lname ? client.lname : ""}
            </Heading>
            <Flex gap={{ base: 1, md: 4 }} direction={{ base: "column", md: "row" }} color="stone.700">
              <Text>{client.phone}</Text>
              {client.email && <Text overflowWrap="anywhere">{client.email}</Text>}
            </Flex>
          </Box>
        </Flex>
        <Flex gap={2} wrap="wrap">
          <Button as={Link} to={`/admin/userFamily/${id}`} variant="outline" size="sm">
            Family ({family.length})
          </Button>
          <Button variant="outline" size="sm" onClick={openUser}>Edit</Button>
          <Button variant="danger" size="sm" onClick={() => setIsDeleteUserOpen(true)}>Delete</Button>
        </Flex>
      </Flex>

      <Panel as="section" aria-label="Account" mb={4} px={{ base: 4, md: 6 }} py={4}>
        <Grid templateColumns={{ base: "1fr 1fr", md: "repeat(5, 1fr)" }} gap={{ base: 4, md: 6 }} alignItems="start">
          <Figure label="Paid" value={client.paidAmmount} />
          <Figure
            label="Remaining"
            value={client.remainAmmount}
            note={client.remainAmmount > 0 ? "Owed" : "Settled"}
            owed={client.remainAmmount > 0}
          />
          <Figure label="Total" value={total} />
          <Figure label="Expense" value={client.expense} />
          <Figure label="Net" value={total - client.expense} closing />
        </Grid>
      </Panel>

      <Panel as="section" aria-label="Client details" mb={8} px={{ base: 4, md: 6 }} py={4}>
        <Grid templateColumns={{ base: "1fr 1fr", md: "repeat(3, 1fr)", xl: "repeat(4, 1fr)" }} columnGap={6} rowGap={4}>
          <Fact label="Date of birth">{client.DOB}</Fact>
          <Fact label="Time of birth">{client.TOB}</Fact>
          <Fact label="Place of birth">{client.POB}</Fact>
          <Fact label="Nakshatram">{client.nakshatra}</Fact>
          <Fact label="Gothram">{client.gothram}</Fact>
          <Fact label="Occupation">{client.occupation}</Fact>
          <Fact label="Address" wide>{client.address}</Fact>
        </Grid>
      </Panel>

      <SectionTitle>Bookings</SectionTitle>
      <FilterTabs
        active={activeTab}
        onChange={setBookingTab}
        tabs={[
          { key: "appointments", label: "Appointments", count: bookings.appointments.length },
          { key: "events", label: "Events", count: bookings.events.length },
          { key: "astro", label: "Astro", count: bookings.astro.length },
        ]}
      />

      {activeTab === "appointments" && (
        <Ledger
          columns="minmax(0,1.3fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1.4fr) 110px 210px"
          heads={["Name", "Scheduled", "Submitted", "Notes", "Status", ""]}
          isEmpty={bookings.appointments.length === 0}
          emptyText="No appointments for this client yet."
        >
          {bookings.appointments.map((el) => (
            <LedgerRow key={el._id}>
              <Cell full>
                <Text fontWeight={600}>{el.fname} {el.lname ? el.lname : ""}</Text>
                {el.phone && el.phone !== client.phone && <Text fontSize="sm" color="stone.700">{el.phone}</Text>}
              </Cell>
              <Cell label="Scheduled">
                {el.appointmentDate}
                {el.appointmentTime && <Text fontSize="sm" color="stone.700">{el.appointmentTime}</Text>}
              </Cell>
              <Cell label="Submitted">{el.bookingDate}</Cell>
              <Cell label="Notes" full><Text fontSize="sm" noOfLines={2}>{el.authorMessage}</Text></Cell>
              <Cell label="Status"><StatusMark status={el.appointmentStatus} /></Cell>
              <Cell full>
                <RowActions>
                  <Button variant="outline" size="sm" onClick={() => { openAppointmentModal(el); }}>View</Button>
                  <Button variant="outline" size="sm" onClick={() => { onOpenEditAppointment(el); }}>Edit</Button>
                  <Button variant="danger" size="sm" onClick={() => { setSelectedEvent(el); setIsDeleteAlertOpen(true); }}>Delete</Button>
                </RowActions>
              </Cell>
            </LedgerRow>
          ))}
        </Ledger>
      )}

      {activeTab === "events" && (
        <Ledger
          columns="minmax(0,1.2fr) minmax(0,1.4fr) minmax(0,1fr) 100px 110px 210px"
          heads={["Name", "Event", "Scheduled", "Amount", "Status", ""]}
          isEmpty={bookings.events.length === 0}
          emptyText="No events for this client yet."
        >
          {bookings.events.map((el) => (
            <LedgerRow key={el._id} stripe={el.paymentStatus ? "paid" : "unpaid"}>
              <Cell full>
                <Text fontWeight={600}>{el.fname} {el.lname ? el.lname : ""}</Text>
                {el.phone && el.phone !== client.phone && <Text fontSize="sm" color="stone.700">{el.phone}</Text>}
              </Cell>
              <Cell label="Event" full>
                <Text>{el.eventName ? el.eventName : "Special Event"}</Text>
                {el.faddress && <Text fontSize="sm" color="stone.700" noOfLines={1}>{el.faddress}</Text>}
              </Cell>
              <Cell label="Scheduled">
                {el.eventDate}
                {el.eventTime && <Text fontSize="sm" color="stone.700">{el.eventTime}</Text>}
              </Cell>
              <Cell label="Amount">{rupees(el.ammount)}</Cell>
              <Cell label="Status">
                <Flex direction="column" align="flex-start" gap={1}>
                  <StatusMark status={el.eventStatus} />
                  <StatusMark status={el.paymentStatus ? "Paid" : "Unpaid"} />
                </Flex>
              </Cell>
              <Cell full>
                <RowActions>
                  <Button variant="outline" size="sm" onClick={() => { openEventModal(el); }}>View</Button>
                  <Tooltip label="Letterhead" openDelay={300}>
                    <IconButton
                      variant="outline"
                      size="sm"
                      aria-label="Letterhead"
                      icon={<BsFileEarmarkText size={16} />}
                      onClick={() => setLetterheadEvent(el)}
                    />
                  </Tooltip>
                  <Button variant="outline" size="sm" onClick={() => { openEditEvent(el); }}>Edit</Button>
                  <Button variant="danger" size="sm" onClick={() => { setSelectedEvent(el); setIsDeleteAlertOpenEvent(true); }}>Delete</Button>
                </RowActions>
              </Cell>
            </LedgerRow>
          ))}
        </Ledger>
      )}

      {activeTab === "astro" && (
        <Ledger
          columns="minmax(0,1.3fr) minmax(0,1fr) minmax(0,1.4fr) 100px 110px 210px"
          heads={["Name", "Submitted", "Birth details", "Amount", "Status", ""]}
          isEmpty={bookings.astro.length === 0}
          emptyText="No astro requests for this client yet."
        >
          {bookings.astro.map((el) => (
            <LedgerRow key={el._id} stripe={el.paymentStatus ? "paid" : "unpaid"}>
              <Cell full>
                <Text fontWeight={600}>{el.fname} {el.lname ? el.lname : ""}</Text>
                {el.phone && el.phone !== client.phone && <Text fontSize="sm" color="stone.700">{el.phone}</Text>}
              </Cell>
              <Cell label="Submitted">{el.horoDate}</Cell>
              <Cell label="Birth details" full>
                {el.DOB}
                <Text fontSize="sm" color="stone.700">{[el.TOB, el.POB].filter(Boolean).join(", ")}</Text>
              </Cell>
              <Cell label="Amount">{rupees(el.ammount)}</Cell>
              <Cell label="Status">
                <Flex direction="column" align="flex-start" gap={1}>
                  <StatusMark status={el.horoStatus} />
                  <StatusMark status={el.paymentStatus ? "Paid" : "Unpaid"} />
                </Flex>
              </Cell>
              <Cell full>
                <RowActions>
                  <Button variant="outline" size="sm" onClick={() => { openHoroModal(el); }}>View</Button>
                  <Button variant="outline" size="sm" onClick={() => { openEditHoro(el); }}>Edit</Button>
                  <Button variant="danger" size="sm" onClick={() => { setSelectedEvent(el); setIsDeleteAlertOpenHoro(true); }}>Delete</Button>
                </RowActions>
              </Cell>
            </LedgerRow>
          ))}
        </Ledger>
      )}

      {client.image && (
        <Modal isOpen={photoOpen} onClose={() => setPhotoOpen(false)} size="xl" isCentered>
          <ModalOverlay bg="rgba(35, 26, 30, 0.8)" />
          <ModalContent bg="transparent" boxShadow="none" mx={4} my={4} maxW="min(92vw, 720px)">
            <ModalCloseButton color="white" bg="rgba(35, 26, 30, 0.6)" _hover={{ bg: "rgba(35, 26, 30, 0.8)" }} top={2} right={2} />
            <Image
              src={client.image}
              alt={`Photo of ${client.fname} ${client.lname ? client.lname : ""}`}
              maxH="85vh"
              w="100%"
              objectFit="contain"
              borderRadius="lg"
              bg="white"
            />
          </ModalContent>
        </Modal>
      )}
      {letterheadEvent && (
        <LetterheadSheet event={letterheadEvent} isOpen={Boolean(letterheadEvent)} onClose={() => setLetterheadEvent(null)} />
      )}
      {/* // Appointments Details */}
      {selectedEvent && (
        <Drawer
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpenModal1}
          onClose={onCloseModal1}
          size="lg"
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader
            >
              Appointment Details
            </DrawerHeader>
            <DrawerCloseButton />
            <DrawerBody pb={6}>
              <Grid
                templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                gap={4}
              >
                <FormControl>
                  <FormLabel>Full Name</FormLabel>
                  <Box>{`${selectedEvent.fname} ${selectedEvent.lname ? selectedEvent.lname : ""
                    }`}</Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Mobile number</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.phone}
                  </Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Email</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.email}
                  </Box>
                </FormControl>
                <FormControl>
                  <FormLabel>Submitted Date</FormLabel>
                  <Box>{selectedEvent.bookingDate}</Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Appointment Status</FormLabel>
                  <Box>{selectedEvent.appointmentStatus}</Box>
                </FormControl>
                <FormControl>
                  <FormLabel> Appointment Date</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.appointmentDate}
                  </Box>
                </FormControl>
                <FormControl>
                  <FormLabel> Time</FormLabel>
                  <Box>
                    {selectedEvent.appointmentTime
                      ? selectedEvent.appointmentTime
                      : "00:00"}
                  </Box>
                </FormControl>

                <FormControl>
                  <FormLabel>City</FormLabel>
                  <Box>{selectedEvent.city ? selectedEvent.city : "Not recorded"}</Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Reference</FormLabel>
                  <Box>
                    {selectedEvent.referedby ? selectedEvent.referedby : "Not recorded"}
                  </Box>
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                  scrollBehavior={scrollBehavior}
                >
                  <FormLabel>Message</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                    width="320px"
                    white-space="normal"
                    word-wrap="break-word"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.message}
                  </Box>
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                  scrollBehavior={scrollBehavior}
                >
                  <FormLabel>Author Message</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                    // width="320px"
                    white-space="normal"
                    word-wrap="break-word"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.authorMessage}
                  </Box>
                </FormControl>
              </Grid>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      )}

      {/* Edit Appointment */}
      {selectedEvent && (
        <Drawer
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpenEditApoi1}
          onClose={onCloseEditApoi1}
          size="lg"
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader
            >
              Edit Appointment
            </DrawerHeader>
            <DrawerCloseButton />
            <DrawerBody pb={6}>
              <Grid
                templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                gap={4}
              >
                <FormControl>
                  <FormLabel>First name</FormLabel>
                  <Input
                    name="fname"
                    ref={initialRef}
                    placeholder={selectedEvent.fname}
                    onChange={handleInputChange}
                    value={formData.fname}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Last name</FormLabel>
                  <Input
                    name="lname"
                    placeholder={selectedEvent.lname}
                    onChange={handleInputChange}
                    value={formData.lname}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Date</FormLabel>
                  <Input
                    type="date"
                    name="appointmentDate"
                    placeholder={selectedEvent.appointmentDate}
                    onChange={handleInputChange}
                    min={new Date().toISOString().slice(0, 10)}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Time</FormLabel>
                  <Input
                    type="time"
                    name="appointmentTime"
                    placeholder={selectedEvent.appointmentTime}
                    onChange={handleInputChange}
                    min={new Date().toISOString().slice(0, 10)}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Email</FormLabel>
                  <Input
                    name="email"
                    defaultValue={selectedEvent.email}
                    onChange={handleInputChange}
                    value={formData.email}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>City</FormLabel>
                  <Input
                    name="city"
                    placeholder={
                      selectedEvent.city ? selectedEvent.city : "Not recorded"
                    }
                    onChange={handleInputChange}
                    value={formData.city}
                  />
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                >
                  <FormLabel>Appointment Status</FormLabel>
                  <Select
                    name="appointmentStatus"
                    value={
                      formData.appointmentStatus ||
                      selectedEvent.appointmentStatus
                    }
                    onChange={handleInputChange}
                  >
                    <option value="Pending">Pending</option>
                    <option value="Completed">Completed</option>
                  </Select>
                </FormControl>

                <FormControl>
                  <FormLabel>Reference</FormLabel>
                  <Input
                    name="referedby"
                    defaultValue={selectedEvent.referedby}
                    onChange={handleInputChange}
                    value={formData.referedby}
                  />
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Author Message</FormLabel>
                  <Textarea
                    rows={6}
                    width="100%"
                    defaultValue="Author Message"
                    name="authorMessage"
                    onChange={handleInputChange}
                    value={formData.authorMessage}
                  />
                </FormControl>
              </Grid>
            </DrawerBody>

            <DrawerFooter>
              <Button
                mr={3}
                onClick={() => handleSubmit()}
              >
                Save
              </Button>
              <Button variant="ghost"
                onClick={onCloseEditApoi1}
              >
                Cancel
              </Button>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      )}
      {/* Edit Event */}
      {selectedEvent && (
        <Drawer
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpenEditEvent1}
          onClose={onCloseEditEvent1}
          size="lg"
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader
            >
              Edit Event
            </DrawerHeader>
            <DrawerCloseButton />
            <DrawerBody pb={6}>
              <Grid
                templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                gap={4}
              >
                <FormControl>
                  <FormLabel>First name</FormLabel>
                  <Input
                    name="fname"
                    ref={initialRef}
                    placeholder={selectedEvent.fname}
                    onChange={handleInputChange}
                    value={formData.fname}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Last name</FormLabel>
                  <Input
                    name="lname"
                    placeholder={selectedEvent.lname}
                    onChange={handleInputChange}
                    value={formData.lname}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Email</FormLabel>
                  <Input
                    name="email"
                    placeholder={selectedEvent.email}
                    onChange={handleInputChange}
                    value={formData.email}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Event Status</FormLabel>
                  <Select
                    name="eventStatus"
                    value={formData.eventStatus || selectedEvent.eventStatus}
                    onChange={handleInputChange}
                  >
                    <option value="Pending">Pending</option>
                    <option value="Completed">Completed</option>
                  </Select>
                </FormControl>

                <FormControl>
                  <FormLabel>Date</FormLabel>
                  <Input
                    type="date"
                    name="eventDate"
                    placeholder={selectedEvent.eventDate}
                    onChange={handleInputChange}
                    // value={formData.eventDate}
                    min={new Date().toISOString().slice(0, 10)}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Time</FormLabel>
                  <Input
                    type="time"
                    name="eventTime"
                    placeholder={selectedEvent.eventTime}
                    onChange={handleInputChange}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Payment</FormLabel>
                  <Select
                    name="paymentStatus"
                    value={
                      formData.paymentStatus || selectedEvent.paymentStatus
                    }
                    onChange={handleInputChange}
                    defaultValue={
                      selectedEvent.paymentStatus ? "paid" : "notPaid"
                    }
                  >
                    <option value={false}>Not Paid</option>
                    <option value={true}>Paid</option>
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel>Amount</FormLabel>
                  <Input
                    placeholder={selectedEvent.ammount}
                    name="ammount"
                    type="number"
                    onChange={handleInputChange}
                    value={formData.ammount}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Upload Image</FormLabel>
                  {/* <Input
                  type="file"
                    placeholder="Image"
                    name="image"
                    onChange={handleInputChange}
                  /> */}
                  <Input
                    type="file"
                    id="imageMobile"
                    name="image"
                    accept="image/*"
                    onChange={handleInputChange}
                    required
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>City</FormLabel>
                  <Input
                    type="text"
                    name="city"
                    placeholder={
                      selectedEvent.city ? selectedEvent.city : "City"
                    }
                    onChange={handleInputChange}
                    value={formData.city}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Expense</FormLabel>

                  <Input
                    name="expense"
                    type="number"
                    onChange={handleInputChange}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Gotram</FormLabel>
                  <Input
                    name="gotram"
                    placeholder={selectedEvent.gotram}
                    onChange={handleInputChange}
                  // value={selectedEvent.gotram}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Reference</FormLabel>
                  <Input
                    name="referedby"
                    defaultValue={selectedEvent.referedby}
                    onChange={handleInputChange}
                    value={formData.referedby}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Occupation</FormLabel>
                  <Input
                    name="occupation"
                    defaultValue={selectedEvent.occupation}
                    onChange={handleInputChange}
                    value={formData.occupation}
                  />
                </FormControl>


                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Nakshatram Details</FormLabel>
                  {selectedEvent.gautarm?.map((el, index) => (
                    <Box key={index}>
                      <Input
                        width={"50%"}
                        name={`gautarm-${index}-name`}
                        placeholder="Enter Person Name"
                        defaultValue={el.name}
                        onChange={handleInputChange} // Update name field
                      />

                      <Input
                        width={"50%"}
                        name={`gautarm-${index}-gautaram`}
                        placeholder="Enter Nakshatram"
                        defaultValue={el.gautaram}
                        onChange={handleInputChange} // Update gautaram field
                      />
                    </Box>
                  ))}
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Event Venue</FormLabel>
                  <Textarea
                    name="address"
                    defaultValue={selectedEvent.address}
                    onChange={handleInputChange}
                    value={formData.address}
                  />
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Full Address</FormLabel>
                  <Textarea
                    name="faddress"
                    defaultValue={selectedEvent.faddress}
                    onChange={handleInputChange}
                    value={formData.faddress}
                  />
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Author Message</FormLabel>
                  <Textarea
                    rows={6}
                    defaultValue={selectedEvent.authorMessage}
                    name="authorMessage"
                    onChange={handleInputChange}
                    value={formData.authorMessage}
                  />
                  
                </FormControl>
              </Grid>
            </DrawerBody>

            <DrawerFooter>
              <Button
                mr={3}
                onClick={() => {
                  setIsLoading(true);
                  handleSubmitEvent().finally(() => setIsLoading(false));
                }}
              >
                {isLoading ? <Spinner size="sm" color="white" /> : "Save"}
              </Button>
              <Button variant="ghost"
                onClick={onCloseEditEvent1}
              >
                Cancel
              </Button>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      )}
      {/* Details Event */}

      {selectedEvent && (
        <Drawer
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpenModal2}
          onClose={onCloseModal2}
          size="lg"
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader
            >
              Event Details
            </DrawerHeader>
            <DrawerCloseButton />
            <DrawerBody pb={6}>
              <Grid
                templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                gap={4}
              >
                <FormControl>
                  <FormLabel>Full Name</FormLabel>
                  <Box>{`${selectedEvent.fname} ${selectedEvent.lname ? selectedEvent.lname : ""
                    }`}</Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Mobile number</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.phone}
                  </Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Email</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.email}
                  </Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Event Status</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.eventStatus}
                  </Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Date</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.eventDate}
                  </Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Time</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.eventTime}
                  </Box>
                </FormControl>
                <FormControl>
                  <FormLabel>Amount</FormLabel>
                  <Box>{selectedEvent.ammount}</Box>
                </FormControl>
                <FormControl>
                  <FormLabel>Payment Status</FormLabel>
                  <Box>
                    {selectedEvent.paymentStatus ? (
                      <span style={{ color: "green" }}>Paid</span>
                    ) : (
                      <span style={{ color: "red" }}>Not Paid</span>
                    )}
                  </Box>
                </FormControl>
                <FormControl>
                  <FormLabel>City</FormLabel>
                  <Box>{selectedEvent.city ? selectedEvent.city : "Not recorded"}</Box>
                </FormControl>
                <FormControl>
                  <FormLabel> Submitted Date</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.bookingDate}
                  </Box>
                </FormControl>
                <FormControl
                  width="100%"
                >
                  <FormLabel>Expense</FormLabel>
                  <Box>{selectedEvent.expense}</Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Gotram</FormLabel>
                  <Box
                    name="gotram"
                    ref={initialRef}
                    placeholder="gotram"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.gotram}
                  </Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Reference</FormLabel>
                  <Box>
                    {selectedEvent.referedby ? selectedEvent.referedby : "Not recorded"}
                  </Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Occupation</FormLabel>
                  <Box>
                    {selectedEvent.occupation ? selectedEvent.occupation : "Not recorded"}
                  </Box>
                </FormControl>


                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Event Venue</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="Event Venue"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >{`${selectedEvent.address}, ${selectedEvent.pincode}`}</Box>
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Full Address</FormLabel>
                  <Box
                    name="faddress"
                    ref={initialRef}
                    placeholder="Full Address"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >{`${selectedEvent.faddress}, ${selectedEvent.pincode}`}</Box>
                </FormControl>
                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Assignees</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.assignees ? selectedEvent.assignees.map((assi)=>
                  
                  assi.assigned?<button style={{padding:"2px 8px",backgroundColor:"#FCEFC7",margin:"4px",borderRadius:"3px",fontWeight:600}}>{assi.name} - {assi.eamount}</button>:""
                  ) : "None"}
                  </Box>
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Nakshatram Details</FormLabel>
                  {selectedEvent.gautarm?.map((el, index) => (
                    <Box key={index}>
                      {el.name && (
                        <>
                          {el.name}
                          {" - "}
                        </>
                      )}
                      {el.gautaram && <>{el.gautaram}</>}
                    </Box>
                  ))}
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Message</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.message ? selectedEvent.message : "Not recorded"}
                  </Box>
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Author Message</FormLabel>
                  <Box
                    name="fname"
                    ref={initialRef}
                    placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                  >
                    {selectedEvent.authorMessage
                      ? selectedEvent.authorMessage
                      : "Not recorded"}
                  </Box>
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                >
                  <FormLabel>Event Image</FormLabel>
                  <Image
                    src={
                      selectedEvent.image
                        ? selectedEvent.image
                        : "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg"
                    }
                  />
                </FormControl>
              </Grid>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      )}

      {/* // Horo Details */}
      {selectedEvent && (
        <Drawer
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpenModalHoro}
          onClose={onCloseModalHoro}
          size="lg"
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader
            >
              Astro Details
            </DrawerHeader>
            <DrawerCloseButton />
            <DrawerBody pb={6}>
              <Grid
                templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                gap={4}
              >
                <FormControl>
                  <FormLabel>Full Name</FormLabel>
                  <Box>{`${selectedEvent.fname} ${selectedEvent.lname ? selectedEvent.lname : ""
                    }`}</Box>
                </FormControl>
                <FormControl>
                  <FormLabel>Mobile number</FormLabel>
                  <Box>{selectedEvent.phone}</Box>
                </FormControl>
                <FormControl>
                  <FormLabel>Email</FormLabel>
                  <Box>{selectedEvent.email}</Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Nakshatram</FormLabel>
                  <Box>{selectedEvent.nakshatra}</Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Date Of Birth</FormLabel>
                  <Box>{selectedEvent.DOB}</Box>
                </FormControl>
                <FormControl>
                  <FormLabel>Time Of Birth</FormLabel>
                  <Box>{selectedEvent.TOB}</Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Place Of Birth</FormLabel>
                  <Box>{selectedEvent.POB}</Box>
                </FormControl>
                <FormControl>
                  <FormLabel>Astro Status</FormLabel>
                  <Box>{selectedEvent.horoStatus}</Box>
                </FormControl>
                <FormControl>
                  <FormLabel>Amount</FormLabel>
                  <Box>{selectedEvent.ammount}</Box>
                </FormControl>
                <FormControl>
                  <FormLabel>Payment Status</FormLabel>
                  <Box>
                    {selectedEvent.paymentStatus ? (
                      <span style={{ color: "green" }}>Paid</span>
                    ) : (
                      <span style={{ color: "red" }}>Not Paid</span>
                    )}
                  </Box>
                </FormControl>
                <FormControl>
                  <FormLabel>City</FormLabel>
                  <Box>{selectedEvent.city}</Box>
                </FormControl>
                <FormControl>
                  <FormLabel>Submission Date</FormLabel>
                  <Box>{selectedEvent.horoDate}</Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Reference</FormLabel>
                  <Box>
                    {selectedEvent.referedby ? selectedEvent.referedby : "Not recorded"}
                  </Box>
                </FormControl>

                <FormControl>
                  <FormLabel>Occupation</FormLabel>
                  <Box>
                    {selectedEvent.occupation ? selectedEvent.occupation : "Not recorded"}
                  </Box>
                </FormControl>
                
                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Full address</FormLabel>
                  <Box>{`${selectedEvent.address}`}</Box>
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Message</FormLabel>
                  <Box>{selectedEvent.message}</Box>
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Author Message</FormLabel>
                  <Box name="fname">{selectedEvent.authorMessage}</Box>
                </FormControl>
                <FormControl
                  gridColumn="1 / -1"
                >
                  <FormLabel>Astro Image</FormLabel>
                  <Image
                    src={
                      selectedEvent.image
                        ? selectedEvent.image
                        : "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg"
                    }
                  />
                </FormControl>
              </Grid>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      )}

      {/* Edit Horo */}
      {selectedEvent && (
        <Drawer
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpenEditHoro}
          onClose={onCloseEditHoro}
          size="lg"
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader
            >
              Edit Astro
            </DrawerHeader>
            <DrawerCloseButton />
            <DrawerBody pb={6}>
              <Grid
                templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                gap={4}
              >
                <FormControl>
                  <FormLabel>First name</FormLabel>
                  <Input
                    name="fname"
                    ref={initialRef}
                    placeholder={selectedEvent.fname}
                    onChange={handleInputChange}
                    value={formData.fname}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Last name</FormLabel>
                  <Input
                    name="lname"
                    placeholder={selectedEvent.lname}
                    onChange={handleInputChange}
                    value={formData.lname}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Email</FormLabel>
                  <Input
                    name="email"
                    placeholder={selectedEvent.email}
                    onChange={handleInputChange}
                    value={formData.email}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Nakshatram</FormLabel>
                  <Input
                    name="nakshatra"
                    placeholder={selectedEvent.nakshatra}
                    onChange={handleInputChange}
                    value={formData.nakshatra}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Date Of Birth</FormLabel>
                  <Input
                    type="date"
                    name="DOB"
                    placeholder={selectedEvent.DOB}
                    onChange={handleInputChange}
                    max={new Date().toISOString().split("T")[0]}
                  // value={formData.DOB}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Time Of Birth</FormLabel>
                  <Input
                    name="TOB"
                    type="time"
                    placeholder={selectedEvent.TOB}
                    onChange={handleInputChange}
                    value={formData.TOB}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Place Of Birth</FormLabel>
                  <Input
                    name="POB"
                    type="text"
                    value={formData.POB || selectedEvent.POB}
                    onChange={handleInputChange}
                    defaultValue={selectedEvent.POB}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Asto Status</FormLabel>
                  <Select
                    name="horoStatus"
                    value={formData.horoStatus || selectedEvent.horoStatus}
                    onChange={handleInputChange}
                  >
                    <option value="Pending">Pending</option>
                    <option value="Completed">Completed</option>
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel>Payment</FormLabel>
                  <Select
                    name="paymentStatus"
                    value={
                      formData.paymentStatus || selectedEvent.paymentStatus
                    }
                    onChange={handleInputChange}
                    defaultValue={
                      selectedEvent.paymentStatus ? "paid" : "notPaid"
                    }
                  >
                    <option value={false}>Not Paid</option>
                    <option value={true}>Paid</option>
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel>Amount</FormLabel>
                  <Input
                    placeholder={selectedEvent.ammount}
                    name="ammount"
                    type="number"
                    onChange={handleInputChange}
                    value={formData.ammount}
                  />
                </FormControl>
                <FormControl
                  width="100%"
                >
                  <FormLabel>Upload Image</FormLabel>
                  
                  <Input
                    type="file"
                    id="imageMobile"
                    name="image"
                    accept="image/*"
                    onChange={handleInputChange}
                    required
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>City</FormLabel>
                  <Input
                    name="city"
                    placeholder={
                      selectedEvent.city ? selectedEvent.city : "Not recorded"
                    }
                    onChange={handleInputChange}
                    value={formData.city}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Reference</FormLabel>
                  <Input
                    name="referedby"
                    defaultValue={selectedEvent.referedby}
                    onChange={handleInputChange}
                    value={formData.referedby}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Occupation</FormLabel>
                  <Input
                    name="occupation"
                    defaultValue={selectedEvent.occupation}
                    onChange={handleInputChange}
                    value={formData.occupation}
                  />
                </FormControl>

               
                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Full address</FormLabel>
                  <Textarea
                    name="address"
                    defaultValue={selectedEvent.address}
                    onChange={handleInputChange}
                    value={formData.address}
                  />
                </FormControl>

                <FormControl
                  gridColumn="1 / -1"
                >
                  <FormLabel>Author Message</FormLabel>
                  <Textarea
                    rows={6}
                    defaultValue={selectedEvent.authorMessage}
                    name="authorMessage"
                    onChange={handleInputChange}
                    value={formData.authorMessage}
                  />
                </FormControl>

                {/* <FormControl gridColumn={{ base: "1 / span 2", md: "auto" }}>
                  <FormLabel>Upload Image</FormLabel>
                 
                  <Input
                        type="file"
                        id="imageMobile"
                        name="image"
                        accept="image/*"
                        onChange={ handleInputChange}
                        required
                    />
                </FormControl> */}
              </Grid>
            </DrawerBody>

            <DrawerFooter>
              <Button
                mr={3}
                onClick={() => {
                  setIsLoading(true); // Set isLoading to true when the button is clicked
                  handleSubmitHoro().finally(() => setIsLoading(false)); // Reset isLoading to false after the update is complete or if there's an error
                }}
              >
                {isLoading ? <Spinner size="sm" color="white" /> : "Save"}
              </Button>
              <Button variant="ghost"
                onClick={onCloseEditHoro}
              >
                Cancel
              </Button>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      )}

      {selectedEvent && (
        <Drawer
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpenUser}
          onClose={onCloseUser}
          size="lg"
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader
            >
              Edit User
            </DrawerHeader>
            <DrawerCloseButton />
            <DrawerBody pb={6}>
              <Grid
                templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                gap={4}
              >
                <FormControl>
                  <FormLabel>First name</FormLabel>
                  <Input
                    name="fname"
                    ref={initialRef}
                    placeholder={selectedEvent.fname}
                    onChange={handleInputChange}
                    value={formData.fname}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Last name</FormLabel>
                  <Input
                    name="lname"
                    placeholder={selectedEvent.lname}
                    onChange={handleInputChange}
                    value={formData.lname}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Email</FormLabel>
                  <Input
                    name="email"
                    placeholder={selectedEvent.email}
                    onChange={handleInputChange}
                    value={formData.email}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Full address</FormLabel>
                  <Input
                    name="address"
                    defaultValue={selectedEvent.address}
                    onChange={handleInputChange}
                    value={formData.address}
                  />
                </FormControl>

                {/* <FormControl gridColumn={{ base: "1 / span 2", md: "auto" }}>
                  <FormLabel>Pin code</FormLabel>
                  <Input
                    name="pincode"
                    placeholder={selectedEvent.pincode}
                    onChange={handleInputChange}
                    value={formData.pincode}
                  />
                </FormControl> */}

                <FormControl>
                  <FormLabel>Date Of Birth</FormLabel>
                  <Input
                    type="date"
                    name="DOB"
                    max={new Date().toISOString().split("T")[0]}
                    // value={formData.DOB}
                    onChange={handleInputChange}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Time Of Birth</FormLabel>
                  <Input
                    type="time"
                    name="TOB"
                    value={formData.TOB}
                    onChange={handleInputChange}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Place Of Birth</FormLabel>
                  <Input
                    name="POB"
                    placeholder="Enter Your Birth Place "
                    value={formData.POB}
                    onChange={handleInputChange}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Nakshatram</FormLabel>
                  <Input
                    name="nakshatra"
                    placeholder="Enter Your Nakshatram "
                    value={formData.nakshatra}
                    onChange={handleInputChange}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Gothram</FormLabel>
                  <Input
                    name="gothram"
                    placeholder="Enter Your Gothram "
                    value={formData.gothram}
                    onChange={handleInputChange}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Occupation</FormLabel>
                  <Input
                    name="occupation"
                    placeholder="Enter Your Occupation "
                    defaultValue={selectedEvent.occupation?selectedEvent.occupation:""}
                    value={formData.occupation}
                    onChange={handleInputChange}
                  />
                </FormControl>
                <FormControl
                  gridColumn="1 / -1"
                  width="100%"
                >
                  <FormLabel>Upload Image</FormLabel>
                  {/* <Input
                  type="file"
                    placeholder="Image"
                    name="image"
                    onChange={handleInputChange}
                  /> */}
                  <Input
                    type="file"
                    id="imageMobile"
                    name="image"
                    accept="image/*"
                    onChange={handleInputChange}
                    required
                  />
                </FormControl>
              </Grid>
            </DrawerBody>

            <DrawerFooter>
              <Button
                mr={3}
                onClick={() => {
                  setIsLoading(true); // Set isLoading to true when the button is clicked
                  hendelUserD().finally(() => setIsLoading(false)); // Reset isLoading to false after the update is complete or if there's an error
                }}
              >
                {isLoading ? <Spinner size="sm" color="white" /> : "Save"}
              </Button>
              <Button variant="ghost"
                onClick={onCloseUser}
              >
                Cancel
              </Button>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      )}
      <AlertDialog
        isOpen={isDeleteAlertOpen}
        leastDestructiveRef={finalRef}
        onClose={() => setIsDeleteAlertOpen(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Confirmation
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this appointment?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button variant="ghost"
                ref={finalRef}
                onClick={() => setIsDeleteAlertOpen(false)}
              >
                Cancel
              </Button>
              <Button variant="dangerSolid"
                onClick={onDeleteConfirm}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <AlertDialog
        isOpen={isDeleteUserOpen}
        leastDestructiveRef={finalRef}
        onClose={() => setIsDeleteUserOpen(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Confirmation
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this User?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button variant="ghost"
                ref={finalRef}
                onClick={() => setIsDeleteUserOpen(false)}
              >
                Cancel
              </Button>
              <Button variant="dangerSolid"
                onClick={onDeleteConfirmUser}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <AlertDialog
        isOpen={isDeleteAlertOpenEvent}
        leastDestructiveRef={finalRef}
        onClose={() => setIsDeleteAlertOpenEvent(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Confirmation
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this Event?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button variant="ghost"
                ref={finalRef}
                onClick={() => setIsDeleteAlertOpenEvent(false)}
              >
                Cancel
              </Button>
              <Button variant="dangerSolid"
                onClick={onDeleteConfirmEvent}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <AlertDialog
        isOpen={isDeleteAlertOpenHoro}
        leastDestructiveRef={finalRef}
        onClose={() => setIsDeleteAlertOpenHoro(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Confirmation
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this Astro?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button variant="ghost"
                ref={finalRef}
                onClick={() => setIsDeleteAlertOpenHoro(false)}
              >
                Cancel
              </Button>
              <Button variant="dangerSolid"
                onClick={onDeleteConfirmHoro}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
